import type { SupportedLanguageFromApi } from '../../transcriptionSlice/transcriptionSlice.types';

export interface SupportedLanguage {
  code: string;
  name: string;
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },
  { code: 'it', name: 'Italian' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'ru', name: 'Russian' },
  { code: 'ja', name: 'Japanese' },
  { code: 'ko', name: 'Korean' },
  { code: 'zh', name: 'Chinese (Mandarin)' },
  { code: 'nl', name: 'Dutch' },
  { code: 'hi', name: 'Hindi' },
  { code: 'pl', name: 'Polish' },
  { code: 'tr', name: 'Turkish' },
  { code: 'uk', name: 'Ukrainian' },
  { code: 'da', name: 'Danish' },
  { code: 'sv', name: 'Swedish' },
  { code: 'no', name: 'Norwegian' },
  { code: 'fi', name: 'Finnish' },
  { code: 'id', name: 'Indonesian' },
  { code: 'ms', name: 'Malay' },
  { code: 'vi', name: 'Vietnamese' },
  { code: 'th', name: 'Thai' },
  { code: 'ta', name: 'Tamil' },
  { code: 'te', name: 'Telugu' },
];

export const DEFAULT_SUPPORTED_LANGUAGES_FALLBACK = SUPPORTED_LANGUAGES;

export const getLanguageByCode = (
  code: string,
): SupportedLanguage | undefined =>
  SUPPORTED_LANGUAGES.find(lang => lang.code === code);

export const getLanguageNameByCode = (
  code: string,
  languagesFromApi?: SupportedLanguageFromApi[],
): string => {
  if (languagesFromApi) {
    const apiLanguage = languagesFromApi.find(lang => lang.code === code);
    if (apiLanguage) {
      return apiLanguage.name;
    }
  }
  return getLanguageByCode(code)?.name || code;
};
